import { DateTool } from "@js/date-tool.js";
import dayjs from "dayjs";
import axios from "axios";

class ReportModel {
  constructor(model) {
    this.model = model;

    //报告类型
    this.reportTemplateType = this._initReportTemplateType();

    //报告显示信息
    this.isCombineBloodOxygenAndPulse = !!parseInt(this.model.reportInfo.bloodPulse);
    this.isCombinePeriodAndEvent = !!parseInt(this.model.reportInfo.stageEvent);
    this.isPage2BreakAtPosition1 = this._initIsPage2BreakAtPosition1();
    this.isPage3BreakAtPosition1 = this._initIsPage3BreakAtPosition1();
    this.isShowAverageBreathRate = this._initIsShowAverageBreathRate();
    // 报告信息
    this.reportModeType = this._initReportModeType();
    this.hospitalIcon = this._initHospitalIcon();
    this.reportTitleArray = this._initReportTitleArray();
    this.reportSubtitle = this._initReportSubtitle();
    this.reportId = this._initReportId();
    //操作员信息
    this.initialOperator = this._initInitialOperator();
    this.initialReviewer = this._initInitialReviewer();
    this.initialDepartment = this._initInitialPatientDepartment();
    // 用户信息
    this.initialPatientName = this._initInitialPatientName();
    this.initialPatientHeight = this._initInitialPatientHeight();
    this.initialPatientAge = this._initInitialPatientAge();
    this.initialPatientDepartment = this._initInitialPatientDepartment();
    this.initInitialMobile = this._initInitialMobile();
    this.initialPatientAdmissionNumber = this._initInitialPatientAdmissionNumber();
    this.initialPatientGender = this._initInitialPatientGender();
    this.initialPatientBMI = this._initInitialPatientBMI();
    this.initialPatientWeight = this._initInitialPatientWeight();
    this.initialPatientBedNumber = this._initInitialPatientBedNumber();
    this.initialPatientDiagnoseNumber = this._initInitialPatientDiagnoseNumber();
    this.initialPatientNeckCircumference = this._initInitialPatientNeckCircumference();
    this.initialAR = this._initInitialAR();
    this.initialTonsils = this._initInitialTonsils();
    this.initialAdenoids = this._initInitialAdenoids();
    this.initialThroat = this._initInitialThroat();
    this.initialThroatReflux = this._initInitialThroatReflux();
    this.initialSleepOpenMouth = this._initInitialSleepOpenMouth();
    this.initialAllergen = this._initInitialAllergen();
    //时间原始值（后面计算的基础）
    this.startRecordRawTime = this._initStartRecordRawTime(); //仪器开始记录时间（体动占比、体动幅度图表开始时间）
    this.ringStartRecordRawTime = this._initRingStartRecordRawTime(); //戒指开始记录时间（血氧、脉率图表开始时间）
    this.startPeriodRawTime = this._initStartPeriodRawTime(); //睡眠分期开始时间（分期趋势、呼吸事件开始时间）
    this.startTrendRawTime = this._initStartTrendRawTime(); //呼吸趋势开始时间（呼吸率开始时间）
    this.startSleepRawTime = this._initStartSleepRawTime(); //开始入睡时间
    this.stopRecordRawTime = this._initStopRecordRawTime(); //结束记录时间
    this.stopPeriodRawTime = this._initStopPeriodRawTime(); //睡眠分期结束时间
    this.stopSleepRawTime = this._initStopSleepRawTime(); //结束睡眠时间
    this.startMonitorRawTime = this._initStartMonitorRawTime(); //开始监测时间（所有图表的结束时间）
    this.stopMonitorRawTime = this._initStopMonitorRawTime(); //结束监测时间（所有图表的结束时间）
    this.bch = this._initInitialPatientBch();
    this.bloodPressure = this._initInitialPatientBloodPressure();
    this.deviceType = this.model.deviceType;
    //数据摘要
    this.ahiTitle = this._initahiTitle(); //AHI或OAHI（部分儿童）
    this.ahi = this._initahi();
    this.ai = this._initai();
    this.leavebedtimes = this._initLeavebedtimes();
    this.breathRateArray = this._initBreathRateArray();
    this.maxBreathRate = this._initMaxBreathRate();
    this.averageBreathRate = this._initAverageBreathRate();
    this.minBreathRate = this._initMinBreathRate();
    //睡眠时间统计
    this.startRecordDate = this._initStartRecordDate();
    this.startRecordTime = this._initStartRecordTime();
    this.startRecordFullTime = this._initStartRecordFullTime();
    this.startSleepTime = this._initStartSleepTime();
    this.createDate = this._initCreateDate(); //和stopRecord取同一个时间
    this.stopRecordTime = this._initStopRecordTime();
    this.stopRecordFullTime = this._initStopRecordFullTime();
    this.stopSleepTime = this._initStopSleepTime();
    this.sleepEfficiency = this._initSleepEfficiency();
    this.sleepTime = this._initSleepTime();
    this.totalMonitoringDuration = this._initTotalmonitoringDuration();
    this.totalSleepMinutes = this._initTotalSleepMinutes();
    this.lightonTime = this._initLightonTime();
    this.lightoffTime = this._initLightoffTime();
    this.sleepLatency = this._initSleepLatency();
    this.remLatency = this._initRemLatency();

    //睡眠呼吸事件
    this.averageApneaTime = this._initAverageApneaTime(); //平均暂停和低通气时间
    this.maxApneaTime = this._initMaxApneaTime(); //最长暂停和低通气时间
    this.maxApneaTip = this._initMaxApneaTip(); //最长暂停和低通气发生时间
    this.breathEventCount = this._initBreathEventCount(); //总呼吸事件数
    this.breathEventTime = this._initBreathEventTime(); //总呼吸事件时间
    this.breathEventRate = this._initBreathEventRate(); //占总记录时间
    this.beohCnt = this._initBEOHCnt(); //阻塞及低通气事件数
    this.beoCnt = this._initBEOCnt(); //阻塞事件数
    this.behCnt = this._initBEHCnt(); //低通气事件数
    this.csaCount = this._initcsaCount(); //中枢性呼吸事件次数
    this.msaCount = this._initmsaCount(); //混合性呼吸事件次数
    //睡眠分期时间
    this.awakeTime = this._initAwakeTime();
    this.awakeRatio = this._initAwakeRatio();
    this.remTime = this._initremTime();
    this.remRatio = this._initremRatio();
    this.n1Time = this._initN1Time();
    this.n1Rate = this._initN1Ratio();
    this.n2Time = this._initN2Time();
    this.n2Rate = this._initN2Ratio();
    this.n3Time = this._initN3Time();
    this.n3Rate = this._initN3Ratio();
    this.lightSleepTime = this._initLightSleepTime();
    this.lightSleepRatio = this._initLightSleepRatio();
    this.deepSleepTime = this._initDeepSleepTime();
    this.deepSleepRatio = this._initDeepSleepRatio();
    this.pieArray = this._initPieArray();
    this.breathingData = this._initBreathingData();
    // 鼾声
    this.snoringBeCnt = this._initSnoringBeCnt();
    this.snoringBeMeanLen = this._initSnoringBeMeanLen();
    this.snoringBeTotalTime = this._initSnoringBeTotalTime();
    //血氧统计
    this.averageBloodOxygenSaturation = this._initAverageBloodOxygenSaturation(); //平均血氧饱和度
    this.minBloodOxygenSaturation = this._initMinBloodOxygenSaturation(); //最低血氧饱和度
    this.oxygenRadiationTimes = this._initOxygenRadiationTimes(); //氧减次数
    this.oxygenRadiationIndex = this._initOxygenRadiationIndex(); //氧减指数
    this.remOxygenReduction = this._initRemOxygenReduction();
    this.nremOxygenReduction = this._initNremOxygenReduction();

    this.bloodOxygen95LastingTime = `${parseInt(this._initBloodOxygen95LastingTime() / 60)}`;
    this.bloodOxygen95LastingSeconds = `${parseInt(this._initBloodOxygen95LastingTime() % 60)}`;
    this.bloodOxygen95Rate = this._initBloodOxygen95Rate();
    this.bloodOxygen90LastingTime = `${parseInt(this._initBloodOxygen90LastingTime() / 60)}`;
    this.bloodOxygen90LastingSeconds = `${parseInt(this._initBloodOxygen90LastingTime() % 60)}`;
    this.bloodOxygen90Rate = this._initBloodOxygen90Rate();
    this.bloodOxygen85LastingTime = `${parseInt(this._initBloodOxygen85LastingTime() / 60)}`;
    this.bloodOxygen85LastingSeconds = `${parseInt(this._initBloodOxygen85LastingTime() % 60)}`;
    this.bloodOxygen85Rate = this._initBloodOxygen85Rate();
    this.bloodOxygen80LastingTime = `${parseInt(this._initBloodOxygen80LastingTime() / 60)}`;
    this.bloodOxygen80LastingSeconds = `${parseInt(this._initBloodOxygen80LastingTime() % 60)}`;
    this.bloodOxygen80Rate = this._initBloodOxygen80Rate();

    // 原始包数据
    this.reportNumber= this.model.reportInfo.reportNumber;
    this.zipFileName=this.model.zipFileName;
    this.deviceType= this.model.deviceType;

    this.formatPercentage = (value) => {
      if (value == null || value === "") return null;
      const num = Number(value);
      return isNaN(num) ? null : num.toFixed(2);
    };

    // 时间转换工具函数：将秒数转换为时分秒格式
    this.formatSecondsToHMS = (seconds) => {
      if (!seconds || seconds === 0 || seconds === "0") return null;
      const totalSeconds = parseInt(seconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const remainingSeconds = totalSeconds % 60;
      return `${hours}小时${minutes}分钟${remainingSeconds}秒`;
    };

    // 时间转换工具函数：将分钟数(小数)转换为时分秒格式
    this.formatMinutesToHMS = (decimalMinutes) => {
      if (!decimalMinutes || decimalMinutes === 0 || decimalMinutes === "0"||decimalMinutes==='--') return null;
      const totalMinutes = parseFloat(decimalMinutes);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = Math.floor(totalMinutes % 60);
      const seconds = Math.round((totalMinutes % 1) * 60);
      return `${hours}小时${minutes}分钟${seconds}秒`;
    };
    
    //血氧饱和度统计
    this.bloodOxygenUnder95TimeStr = placeholderText(
      this.formatMinutesToHMS(this.model?.statistical?.spo2Less95time)
    );
    this.bloodOxygenUnder90TimeStr = placeholderText(
      this.formatMinutesToHMS(this.model?.statistical?.spo2Less90time)
    );
    this.bloodOxygenUnder85TimeStr = placeholderText(
      this.formatMinutesToHMS(this.model?.statistical?.spo2Less85time)
    );
    this.bloodOxygenUnder80TimeStr = placeholderText(
      this.formatMinutesToHMS(this.model?.statistical?.spo2Less80time)
    );
    this.bloodOxygenUnder70TimeStr = placeholderText(
      this.formatMinutesToHMS(this.model?.statistical?.spo2Less70time)
    );
    this.bloodOxygenUnder60TimeStr = placeholderText(
      this.formatMinutesToHMS(this.model?.statistical?.spo2Less60time)
    );
    this.bloodOxygenUnder95Ratio = this.model?.statistical?.spo2Less9TimePercent;
    this.bloodOxygenUnder90Ratio = this.model?.statistical?.spo2Less90TimePercent;
    this.bloodOxygenUnder85Ratio = this.model?.statistical?.spo2Less85TimePercent;
    this.bloodOxygenUnder80Ratio = this.model?.statistical?.spo2Less80TimePercent;
    this.bloodOxygenUnder70Ratio = this.model?.statistical?.spo2Less70TimePercent;
    this.bloodOxygenUnder60Ratio = this.model?.statistical?.spo2Less60TimePercent;
    this.bloodOxygenUnder95RatioStr = placeholderText(
      this.formatPercentage(this.model?.statistical?.spo2Less9TimePercent),
      "%"
    );
    this.bloodOxygenUnder90RatioStr = placeholderText(
      this.formatPercentage(this.model?.statistical?.spo2Less90TimePercent),
      "%"
    );
    this.bloodOxygenUnder85RatioStr = placeholderText(
      this.formatPercentage(this.model?.statistical?.spo2Less85TimePercent),
      "%"
    );
    this.bloodOxygenUnder80RatioStr = placeholderText(
      this.formatPercentage(this.model?.statistical?.spo2Less80TimePercent),
      "%"
    );
    this.bloodOxygenUnder70RatioStr = placeholderText(
      this.formatPercentage(this.model?.statistical?.spo2Less70TimePercent),
      "%"
    );
    this.bloodOxygenUnder60RatioStr = placeholderText(
      this.formatPercentage(this.model?.statistical?.spo2Less60TimePercent),
      "%"
    );

    //微觉醒数据
    this.microArousalData = this._initMicroArousalData();
    //脉率统计
    this.averagePulse = this._initAveragePulse();
    this.maxPulse = this._initMaxPulse();
    this.minPulse = this._initMinPulse();
    //AHI
    this.ahiDegreeArray = this._initahiDegreeArray();
    //评估建议
    this.ahiLevel = this._initahiLevel();
    this.evaluateInfo = this._initEvaluateInfo();
    this.isEditable = this._initIsEditable();
    this.conclusion = this._initConclusion();
    //图表
    this.timeTickArray = []; // 将通过异步方法初始化
    this.timeChartTickArray = this._initTimeChartTickArray();
    this.secondTimeArray = this._composeTimeArray(1);
    this.halfMinuteTimeArray = this._composeTimeArray(30);
    this.minuteTimeArray = this._composeTimeArray(60);
    //是否分别展示阻塞及低通气
    this.isSeprateDisplayBEOH = !!this.model.hyponea;
    //各图表数据为了省内存使用get方法
    this.breathWaveShow = this._initBreathWaveShow();

    this.showReportBottom = this._initShowReportBottom();
  }

  // 异步初始化timeTickArray
  async initTimeTickArray() {
    this.timeTickArray = await this._initTimeTickArray();
  }

  //

  _initReportTemplateType() {
    return this.model.reportInfo.reportTemplateType;
  }

  _initIsPage2BreakAtPosition1() {
    return this.isCombineBloodOxygenAndPulse != true;
  }

  _initIsPage3BreakAtPosition1() {
    return !this.isCombineBloodOxygenAndPulse && !this.isCombinePeriodAndEvent;
  }

  _initIsShowAverageBreathRate() {
    return this.model.reportInfo.hospitalId == 351; //浙江大学医学院附属妇产科医院
  }

  _initHospitalIcon() {
    return this.model.reportInfo.reportLogo;
  }

  // 报告抬头第一行
  _initReportTitleArray() {
    return this.model.reportInfo.reportTitle.split(","); //多医院分行显示（天水市中西医结合医院）
  }

  // 报告抬头第二行
  _initReportSubtitle() {
    let rawSubtitle = this.model.reportInfo.reportSubtitle;
    const childModeStr = this.reportModeType == DEVICE_MONITOR_MODE.儿童模式 ? "（儿童模式）" : "";
    return rawSubtitle + childModeStr;
  }

  _initReportModeType() {
    return this.model.reportInfo.modeType;
  }

  _initReportId() {
    return this.model.reportInfo.id;
  }

  _initCreateDate() {
    if (this.reportTemplateType == REPORT_TEMPLATE.临沧市第二人民医院耳鼻喉科) {
      const createDate = dayjs(this.stopRecordRawTime * 1000);
      const createDateStr = createDate.format("YYYY年MM月DD日");
      const beforeDateStr = createDate.subtract(1, "day").format("YYYY年MM月DD日");
      return `检测时间：${beforeDateStr}-${createDateStr}`;
    }
    return DateTool.timestampToStr(this.stopRecordRawTime, "Y年M月D日");
  }

  _initInitialOperator() {
    return this.model.userInfo.report;
  }

  _initInitialReviewer() {
    return this.model.userInfo.examine;
  }
  _initInitialPatientDepartment() {
    return this.model.userInfo.department;
  }

  _initInitialPatientName() {
    return this.model.userInfo.name;
  }

  _initInitialPatientNeckCircumference() {
    return this.model.userInfo.neckCircumference;
  }

  _initInitialPatientHeight() {
    return this.model.userInfo.height;
  }

  _initInitialPatientAge() {
    if (this.model.userInfo.age && this.model.userInfo.age != 0) {
      return this.model.userInfo.age;
    }
    const birthDay = dayjs(this.model.userInfo.birthday);
    const baseDate = dayjs(this.model.reportInfo.createDat).toDate();
    return DateTool.calculateAgeWithBaseDate(
      birthDay.year(),
      birthDay.month() + 1,
      birthDay.date(),
      baseDate
    );
  }

  _initInitialPatientDepartment() {
    let placeholderDepartemt;
    switch (this.reportTemplateType) {
      case REPORT_TEMPLATE.台州恩泽医疗中心集团恩泽医院:
        placeholderDepartemt = "健康管理中心";
        break;
      case REPORT_TEMPLATE.北京大学深圳医院呼吸内科睡眠检测中心:
      case REPORT_TEMPLATE.山东省立医院集团鲁东医院:
        placeholderDepartemt = "呼吸内科";
        break;
      case REPORT_TEMPLATE.舟山市第二人民医院:
        placeholderDepartemt = "四五病区";
        break;
      case REPORT_TEMPLATE.深圳市儿童医院:
      case REPORT_TEMPLATE.西安交通大学附属儿童医院睡眠监测中心:
        placeholderDepartemt = "耳鼻咽喉头颈外科";
        break;
      case REPORT_TEMPLATE.昆明医科大学第一附属医院内分泌一科:
        placeholderDepartemt = "内分泌一科";
        break;
      case REPORT_TEMPLATE.宣威市中医医院:
        placeholderDepartemt = "肺病科/呼吸与危重症医学科";
        break;
      case REPORT_TEMPLATE.深圳市龙华区中心医院耳鼻喉科:
      case REPORT_TEMPLATE.上海瑞金医院:
        placeholderDepartemt = "耳鼻咽喉科";
        break;
      default:
        break;
    }
    return this.model.userInfo.department ? this.model.userInfo.department : placeholderDepartemt;
  }

  _initShowReportBottom() {
    switch (this.reportTemplateType) {
      case REPORT_TEMPLATE.上海瑞金医院:
        return false;
      default:
        return true;
    }
  }

  _initInitialMobile() {
    return this.model.userInfo.mobile;
  }

  _initInitialPatientAdmissionNumber() {
    return this.model.userInfo.zyh;
  }

  _initInitialPatientGender() {
    if (this.model.userInfo.sex == 1) {
      return "男";
    } else if (this.model.userInfo.sex == 2) {
      return "女";
    } else {
      return this.model.userInfo.sex;
    }
  }

  _initInitialPatientBMI() {
    return this.model.userInfo.bmi;
  }

  _initInitialPatientBch() {
    return this.model.userInfo.bch;
  }
  _initInitialPatientBloodPressure() {
    return this.model.userInfo.bloodPressure;
  }
  // _initInitialPatientNeckCircumference(){
  //   return this.model.userInfo.neckCircumference;
  // }
  _initInitialPatientWeight() {
    return this.model.userInfo.weight;
  }

  _initInitialPatientBedNumber() {
    return this.model.userInfo.bch;
  }

  _initInitialPatientDiagnoseNumber() {
    return this.model.userInfo.mzh;
  }

  _initahi() {
    return this.model.statistical.ahi;
  }

  _initai() {
    return this.model.statistical.ai;
  }

  _initBreathWaveShow() {
    return this.model.breathWaveShow === "1";
  }

  _initInitialAR() {
    return this.model.userInfo.ar;
  }

  _initInitialTonsils() {
    return this.model.userInfo.tonsils;
  }

  _initInitialAdenoids() {
    return this.model.userInfo.adenoids;
  }

  _initInitialThroat() {
    return this.model.userInfo.throat;
  }

  _initInitialThroatReflux() {
    return this.model.userInfo.throatReflux;
  }

  _initInitialSleepOpenMouth() {
    return this.model.userInfo.sleepOpenMouth;
  }

  _initInitialAllergen() {
    return this.model.userInfo.allergen;
  }

  _initahiTitle() {
    if (this.reportModeType == DEVICE_MONITOR_MODE.儿童模式 && this.model.statistical.oahi != "") {
      return "OAHI"; //oahi和ahi值都是一样的，只是名称不同
    } else {
      return "AHI";
    }
  }

  _initahiLevel() {
    return this.model.reportInfo.ahiLevel;
  }

  _initLeavebedtimes() {
    return this.model.statistical.leaveBedTimes;
  }

  _initBreathRateArray() {
    return this.model.detailedArr.bmprlist
      .map((item) => {
        return item[0];
      })
      .filter((item) => {
        return item != 0;
      });
  }

  _initMaxBreathRate() {
    if (this.breathRateArray.length == 0) {
      return "";
    } else {
      return `${Math.max(...this.breathRateArray)}`;
    }
  }

  _initAverageBreathRate() {
    const rawArray = this.model.detailedArr.bmprlist.map((item) => {
      return item[0];
    });
    const validArray = rawArray.filter((item) => {
      return item != 0;
    });
    let sum = 0;
    for (const item of validArray) {
      sum += item;
    }
    const average = sum / validArray.length;
    return `${average.toFixed(0)}`;
  }

  _initMinBreathRate() {
    if (this.breathRateArray.length == 0) {
      return "";
    } else {
      return `${Math.min(...this.breathRateArray)}`;
    }
  }

  _initStartRecordTime() {
    return DateTool.timestampToStr(this.startRecordRawTime, "h:m");
  }

  _initStartRecordFullTime() {
    return DateTool.timestampToStr(this.model.statistical.timeStart, "Y/M/D h:m:s");
  }

  _initStartRecordDate() {
    return DateTool.timestampToStr(this.startRecordRawTime, "Y年M月D日");
  }

  _initStartSleepTime() {
    const time = DateTool.timestampToStr(this.startSleepRawTime, "h:m");
    return time;
  }

  _initStopRecordTime() {
    const time = DateTool.timestampToStr(this.stopRecordRawTime, "h:m");
    return time;
  }

  _initStopRecordFullTime() {
    const timestamp = this.model.statistical.timeEnd;
    // 如果是秒级时间戳，需要转换为毫秒
    const time =
      String(timestamp).length > 10
        ? dayjs(timestamp).format("YYYY/MM/DD HH:mm:ss")
        : dayjs(timestamp * 1000).format("YYYY/MM/DD HH:mm:ss");
    return time;
  }
  _initStopSleepTime() {
    const time = DateTool.timestampToStr(this.stopSleepRawTime, "h：m");
    return time;
  }
  _initSleepEfficiency() {
    return this.model.statistical.sleepEfficiency;
  }

  _initSleepTime() {
   
    const totalMinutes = this.model.statistical.totalSleepTime;
    const hour = Math.floor(totalMinutes / 60); // 小时数
    const minute = Math.round(totalMinutes % 60); // 分钟数
    return `${hour}小时${minute}分`;
  }

  _initTotalmonitoringDuration() {
    const totalSeconds = this.model.statistical.timeEnd - this.model.statistical.timeStart;
    const hour = Math.floor(totalSeconds / 3600); // 小时数
    const minute = Math.round((totalSeconds % 3600) / 60); // 分钟数
    return `${hour}小时${minute}分`;
  }

  _initTotalSleepMinutes() {
    return (
      this.model.statistical.remTime +
      this.model.statistical.lightSleepTime +
      this.model.statistical.deepSleepTime
    );
  }
  _initLightonTime() {
    const time = DateTool.timestampToStr(this.model.statistical.lightonTime, "Y/M/D h:m:s");
    return time;
  }
  _initLightoffTime() {
    const time = DateTool.timestampToStr(this.model.statistical.lightoffTime, "Y/M/D h:m:s");
    return time;
  }

  _initSleepLatency() {
    const time = this.model?.m11bExtendData?.sleepLatency;
    return `${time}分钟`;
  }

  _initRemLatency() {
    const time = this.model?.m11bExtendData?.remLatency;
    return `${time}分钟`;
  }

  _initAverageApneaTime() {
    return `${this.model.statistical.beMeanLen}`;
  }

  _initMaxApneaTime() {
    return `${this.model.statistical.beMaxLen}`;
  }

  _initMaxApneaTip() {
    if (this.model.statistical.beMeanlen == 0) {
      return `该事件发生于：--`;
    } else {
      //事件发生时间早于开始入睡时间（精确到分钟）
      if (this.model.statistical.beMaxLenTime < this.startSleepRawTime - 60) {
        return `该事件发生于：--`;
      } else {
        const time = DateTool.timestampToStr(this.model.statistical.beMaxLenTime, "h：m");
        return `该事件发生于：${time}`;
      }
    }
  }

  _initBreathEventCount() {
    return `${this.model.statistical.beCnt}`;
  }

  _initBreathEventTime() {
    return `${this.model.statistical.beTotalTime}`;
  }

  _initBreathEventRate() {
    return `${this.model.statistical.beTotalRate}`;
  }

  _initBEOHCnt() {
    return `${this.model.statistical.beOhCnt}`;
  }

  _initBEOCnt() {
    return `${this.model.statistical.beoCnt}`;
  }

  _initBEHCnt() {
    return `${this.model.statistical.behCnt}`;
  }

  _initcsaCount() {
    return `${this.model.statistical.becCnt}`;
  }

  _initmsaCount() {
    return `${this.model.statistical.bemCnt}`;
  }

  _initAwakeTime() {
    return `${this.model.statistical.wakeTime}`;
  }

  _initSnoringBeCnt() {
    return this.model.m11bExtendData?.snoreEventTotalNum;
  }
  _initSnoringBeMeanLen() {
    return `${this.model.m11bExtendData?.snoreEventAvgTime} 秒`;
  }
  _initSnoringBeTotalTime() {
    if (this.model.m11bExtendData?.snoreEventTotalTime == null) {
      return "";
    }
    const minutes = Math.round(this.model.m11bExtendData?.snoreEventTotalTime / 60);
    const str = `${minutes}分(占睡眠时间 ${this.model.m11bExtendData?.snoreEventTimePercent}%)`;
    return str;
  }

  _initAwakeRatio() {
    return this.model.statistical.wakeRate;
  }
  _initN1Time() {
    return `${this.model.statistical.n1Time}`;
  }

  _initN1Ratio() {
    return this.model.statistical.n1Rate;
  }

  _initN2Time() {
    return `${this.model.statistical.n2Time}`;
  }

  _initN2Ratio() {
    return this.model.statistical.n2Rate;
  }

  _initN3Time() {
    return `${this.model.statistical.deepSleepTime}`;
  }

  _initN3Ratio() {
    return this.model.statistical.deepSleepRate;
  }

  _initremTime() {
    return `${this.model.statistical.remTime}`;
  }

  _initremRatio() {
    return `${this.model.statistical.remRate}`;
  }

  _initLightSleepTime() {
    return `${this.model.statistical.lightSleepTime}`;
  }

  _initLightSleepRatio() {
    return `${this.model.statistical.lightSleepRate}`;
  }

  _initDeepSleepTime() {
    return `${this.model.statistical.deepSleepTime}`;
  }

  _initDeepSleepRatio() {
    return `${this.model.statistical.deepSleepRate}`;
  }

  _initPieArray() {
    return [
      {
        type: "REM",
        value: this.model.statistical.remTime
      },
      {
        type: "N1",
        value: this.model.statistical.n1Time
      },
      {
        type: "N2",
        value: this.model.statistical.n2Time
      },
      {
        type: "N3",
        value: this.model.statistical.deepSleepTime
      }
    ];
  }
  _initBreathingData() {
    return [
      {
        ...this.model.detailedArr?.respiratoryInfo?.apnea,
        name: "呼吸暂停",
        isParent: true,
        rowspan: 4
      },
      {
        ...this.model.detailedArr?.respiratoryInfo?.obstructive,
        name: "阻塞型",
        isChild: true
      },
      {
        ...this.model.detailedArr?.respiratoryInfo?.central,
        name: "中枢型",
        isChild: true
      },
      {
        ...this.model.detailedArr?.respiratoryInfo?.mixed,
        name: "混合型",
        isChild: true
      },
      {
        ...this.model.detailedArr?.respiratoryInfo?.hypopnea,
        name: "低通气",
        isParent: true
      },
      {
        ...this.model.detailedArr?.respiratoryInfo?.total,
        name: "总数",
        isParent: true
      }
    ];
  }

  _initMicroArousalData() {
    return [
      {
        name: "呼吸相关微觉醒",
        rem: this.model?.m11bExtendData?.microRemBreath,
        nrem: this.model?.m11bExtendData?.microNremBreath,
        awake: this.model?.m11bExtendData?.microBreathTotal
      },
      {
        name: "自发觉醒",
        rem: this.model?.m11bExtendData?.microRemSpontaneity,
        nrem: this.model?.m11bExtendData?.microNremSpontaneity,
        awake: this.model?.m11bExtendData?.microUnbreathTotal
      },
      {
        name: "总数",
        rem: this.model?.m11bExtendData?.microRemTotal,
        nrem: this.model?.m11bExtendData?.microNremTotal,
        awake: this.model?.m11bExtendData?.microAwakeTotal
      },
      {
        name: "觉醒指数",
        rem: this.model?.m11bExtendData?.microRemIndex,
        nrem: this.model?.m11bExtendData?.microNremIndex,
        awake: this.model?.m11bExtendData?.microSleepIndex
      }
    ];
  }

  
  _initAverageBloodOxygenSaturation() {
    return  this.model.statistical.spo2avg==='0'?'--':`${this.model.statistical.spo2avg}`;
  }

  _initMinBloodOxygenSaturation() {
    if(this.model?.statistical.spo2avg==0&&this.model?.statistical.spo2min==0){
      return '--'
    }
    
    return `${this.model.statistical.spo2min}`;
  }

  _initOxygenRadiationTimes() {
    if(this.model?.statistical.spo2avg==0&&this.model?.m11bExtendData.spo2EventNum==0){
      return '--'
    }
    return `${this.model?.m11bExtendData?.spo2EventNum}`;
  }

  _initOxygenRadiationIndex() {
    return `${this.model?.m11bExtendData?.spo2EventIndex}`;
  }

  _initRemOxygenReduction() {
    if(this.model?.statistical.spo2avg==0&&this.model?.m11bExtendData.spo2EventRemNum==0){
      return '--'
    }
    return this.model?.m11bExtendData?.spo2EventRemNum ?? "";
  }

  _initNremOxygenReduction() {
    if(this.model?.statistical.spo2avg==0&&this.model?.m11bExtendData.spo2EventNremNum==0){
      return '--'
    }
    return this.model?.m11bExtendData?.spo2EventNremNum ?? "";
  }

  _initBloodOxygen95LastingTime() {
    return Number(this.model.statistical.spo2Less95time);
  }

  _initBloodOxygen95Rate() {
    return `${this.model.statistical.spo2Less9TimePercent}`;
  }

  _initBloodOxygen90LastingTime() {
    return Number(this.model.statistical.spo2Less90time);
  }

  _initBloodOxygen90Rate() {
    return `${this.model.statistical.spo2Less90TimePercent}`;
  }

  _initBloodOxygen85LastingTime() {
    return Number(this.model.statistical.spo2Less85time);
  }

  _initBloodOxygen85Rate() {
    return `${this.model.statistical.spo2Less85TimePercent}`;
  }

  _initBloodOxygen80LastingTime() {
    return Number(this.model.statistical.spo2Less80time);
  }

  _initBloodOxygen80Rate() {
    return `${this.model.statistical.spo2Less80TimePercent}`;
  }

  _initAveragePulse() {
    return this.model.statistical.prAvg==0?'--':`${this.model.statistical.prAvg}`;
  }

  _initMaxPulse() {
    return this.model.statistical.prMax==0?'--':`${this.model.statistical.prMax} `;
  }

  _initMinPulse() {
    return this.model.statistical.prMin==0?'--':`${this.model.statistical.prMin}`;
  }

  // _initStartRecordRawTime() {
  //   return parseInt(this.model.statistical.startSleepTime / 1000);
  // }

  _initStartRecordRawTime() {
    return parseInt(this.model.statistical.timeStart);
  }

  _initRingStartRecordRawTime() {
    return this.model.statistical.ringTimeStart;
  }

  _initStartPeriodRawTime() {
    return this.startRecordRawTime + this.model.statistical.startStatusTimeMinute * 60;
  }

  _initStartPeriodRawTime() {
    return this.startRecordRawTime + this.model.statistical.startSleepTime * 60;
  }

  _initStartTrendRawTime() {
    return this.model.detailedArr.bmprlistInfo.startTime;
  }

  _initStartSleepRawTime() {
    return this.startRecordRawTime + this.model.statistical.fallSleepTimeMinute * 60;
  }

  _initStopRecordRawTime() {
    return this.startRecordRawTime + this.model.statistical.extraCheckTimeMinute * 60;
  }

  _initStopPeriodRawTime() {
    return this.startRecordRawTime + this.model.statistical.endStatusTimeMinute * 60;
  }

  _initStartMonitorRawTime() {
    return Math.max(
      this.startSleepRawTime - 15 * 60,
      this.startRecordRawTime,
      this.startPeriodRawTime
    );
  }

  _initStopSleepRawTime() {
    // if (this.model.statistical.endSleepTimeMinute == 0) {
    //   //睡眠分期数组尾部0值个数
    //   let zeroCount = 0;
    //   const sleepStagesReverseArray = this.model.detailedArr.sleepdata.reverse();
    //   for (const item of sleepStagesReverseArray) {
    //     if (item == 0) {
    //       zeroCount += 1;
    //     } else {
    //       break;
    //     }
    //   }
    //   //真实的睡眠分期结束时间
    //   const endStatusTimeMinute = this.model.statistical.endStatusTimeMinute - zeroCount;
    //   return this.startRecordRawTime + endStatusTimeMinute * 60;
    // } else {
    //   return this.startRecordRawTime + this.model.statistical.endSleepTimeMinute * 60;
    // }
    return this.model.statistical.timeEnd;
  }

  _initStopMonitorRawTime() {
    return Math.min(
      this.stopRecordRawTime,
      this.stopSleepRawTime + 15 * 60,
      this.stopPeriodRawTime
    );
  }

  //睡眠血氧趋势图表数据
  async bloodOxygenChartDataArray() {
    const ringDataUrl = this.model.detailedArr?.ringData;
    const response = await axios.get(ringDataUrl);
    const ringData = response.data;
    const step = 1;
    const startTime = ringData.starttime * 1000;
    const valueArray = ringData.spo2.map((item) => {
      return item == 0 ? null : item; // 将0值转换为null，图表会自动跳过
    });
    const data = this._composeChartDataArray(step, startTime, valueArray);
    const newData = data.map((item) => ({
      xValue: item.xValue,
      yValue: item.yValue !== null ? parseFloat(parseFloat(item.yValue).toFixed(2)) : null
    }));

    return newData;
  }

  //睡眠脉率趋势图表数据
  async pulseChartDataArray() {
    const ringDataUrl = this.model.detailedArr?.ringData;
    const response = await axios.get(ringDataUrl);
    const ringData = response.data;
    const step = 1;
    const startTime = ringData.starttime * 1000;
    const valueArray = ringData.heartRate.map((item) => {
      return item == "0" ? 0 : Number(item);
    });
    return this._composeChartDataArray(step, startTime, valueArray);
  }

  async microChartDataArray() {
    const microsDataUrl = this.model.detailedArr?.micros;
    const response = await axios.get(microsDataUrl);
    const micros = response.data;
    const chartData = micros.map((item) => ({
      xValue: item.startTime,
      yValue: (item.endTime - item.startTime) / 1000
    }));
    return chartData;
  }

  //睡眠呼吸趋势图表数据
  get breathChartDataArray() {
    const step = 60;
    const startTime = this.startTrendRawTime;
    const valueArray = this.model.detailedArr.bmprlist.map((item) => {
      return item[0] == 0 ? undefined : item[0];
    });
    return this._composeDataArray(step, startTime, valueArray);
  }

  //睡眠分期趋势图表数据
  async getBreathPeriodChartDataArray() {
    const stagesUrl = this.model.detailedArr?.stages;
    const response = await axios.get(stagesUrl);
    const stagesData = response.data;

    // 从stagesData中提取stage数据
    const sleepdata = stagesData.map((item) => item.stage);

    const step = 30;

    const startTime =
      String(this.model?.statistical?.startSleepTime).length > 10
        ? this.model?.statistical?.startSleepTime
        : this.model?.statistical?.startSleepTime * 1000;

    const valueArray = sleepdata.map((item, index) => {
      switch (item) {
        case 6: //离床
          //判断是否单独的一个6
          const lastItem = sleepdata[index - 1];
          const nextItem = sleepdata[index + 1];
          if (lastItem != 6 && nextItem != 6) {
            return mapValue(lastItem);
          } else {
            return null;
          }
        default:
          return mapValue(item);
      }
    });

    const dataArray = this._composeChartDataArray(step, startTime, valueArray);

    return dataArray;

    function mapValue(rawValue) {
      switch (rawValue) {
        case 1: //W
          return 5;
        case 2: //R
          return 4;
        case 3: //N1
          return 3;
        case 4: //N2
          return 2;
        case 5: //N3
          return 1;
        default:
          return null;
      }
    }
  }

  get breathLeavePeriodChartDataArray() {
    const step = this.ringSN.startsWith("M11B") ? 30 : 60;
    const startTime = this.startPeriodRawTime;
    const valueArray = this.model.detailedArr.sleepdata.map((item, index) => {
      switch (item) {
        case 6: //离床
          //判断是否单独的一个6
          const lastItem = this.model.detailedArr.sleepdata[index - 1];
          const nextItem = this.model.detailedArr.sleepdata[index + 1];
          if (lastItem != 6 && nextItem != 6) {
            return mapValue(lastItem);
          } else {
            return 4;
          }
        default:
          return mapValue(item);
      }
    });
    const dataArray = this._composeDataArray(step, startTime, valueArray);
    return dataArray;

    function mapValue(rawValue) {
      switch (rawValue) {
        case 6: //离床
          return 4;
        default:
          return null;
      }
    }
  }

  // 睡眠分期趋势图表数据  以秒为单位补全数据
  get breathPeriodChartDataArray2() {
    const isSecond = true; // 使用秒作为时间单位
    const startTime = this.startPeriodRawTime;
    const valueArray = [];

    let secondIndex = 0;
    for (
      let minuteIndex = 0;
      minuteIndex < this.model.detailedArr.sleepdata.length;
      minuteIndex++
    ) {
      const minuteValue = this.model.detailedArr.sleepdata[minuteIndex];
      for (let i = 0; i < 60; i++) {
        let sleepStageValue;
        switch (minuteValue) {
          case 0: // 清醒
            sleepStageValue = 4;
            break;
          case 2: // 眼动
            sleepStageValue = 3;
            break;
          case 3: // 浅睡
            sleepStageValue = 2;
            break;
          case 4: // 深睡
            sleepStageValue = 1;
            break;
          default:
            sleepStageValue = 0;
            break;
        }
        valueArray.push({
          xValue: (startTime + secondIndex) * 1000,
          yValue: sleepStageValue
        });
        secondIndex++;
      }
    }

    return valueArray;
  }

  //睡眠呼吸事件图表数据
  // get breathEventChartDataArray() {
  //   const step = 1;
  //   const startTime = this.startPeriodRawTime;
  //   let valueArray = new Array(this.secondTimeArray.length).fill(0);
  //   for (const item of this.model.detailedArr.breatheventvect) {
  //     const index = this.secondTimeArray.indexOf(item[0]);
  //     valueArray[index] = item[1];
  //   }
  //   return this._composeDataArray(step, startTime, valueArray);
  // }

  async breathEventChartDataArray() {
    const eventDataUrl = this.model.detailedArr?.events;
    const response = await axios.get(eventDataUrl);
    const breathData = response.data;

    // 事件类型枚举映射
    const eventTypeMap = {
      0: "mixed", // 混合型
      2: "obstructive", // 阻塞型
      3: "hypopnea", // 低通气
      1: "central", // 中枢型
      10: "desaturation" // 氧减
    };

    // 中英文对照（用于显示）
    const eventTypeNameMap = {
      mixed: "混合型",
      obstructive: "阻塞型",
      hypopnea: "低通气",
      central: "中枢型",
      desaturation: "氧减"
    };

    // 按事件类型分类
    const chartData = {
      central: [], // 中枢型
      obstructive: [], // 阻塞型
      mixed: [], // 混合型
      hypopnea: [], // 低通气
      desaturation: [] // 氧减
    };

    // 遍历数据并分类
    breathData.forEach((item) => {
      const dataPoint = {
        xValue: item.startTime,
        yValue: (item.endTime - item.startTime) / 1000
      };

      const typeKey = eventTypeMap[item.eventType];
      if (typeKey && chartData[typeKey]) {
        chartData[typeKey].push(dataPoint);
      }
    });

    return chartData;
  }

  //睡眠体动占比图表数据
  get moveRateChartDataArray() {
    const step = 60;
    const startTime = this.startRecordRawTime;
    const valueArray = this.model.detailedArr.bodymovelist.map((item) => {
      return item[0];
    });
    return this._composeDataArray(step, startTime, valueArray);
  }

  //睡眠体动幅度图表数据
  // get moveRangeChartDataArray() {
  //   const step = 60;
  //   const startTime = this.startRecordRawTime;
  //   const valueArray = this.model.detailedArr.bodymovelist.map((item) => {
  //     return item[1];
  //   });
  //   return this._composeDataArray(step, startTime, valueArray);
  // }

  async moveRangeChartDataArray() {
    const ringDataUrl = this.model.detailedArr?.ringData;
    const response = await axios.get(ringDataUrl);
    const ringData = response.data;

    const bodyMoveValueUrl = this.model.detailedArr?.bodyMoveValue;
    const response_body = await axios.get(bodyMoveValueUrl);
    const bodyMoveValue = response_body.data;

    const step = 0.1;
    const startTime = ringData.starttime * 1000;
    const valueArray = bodyMoveValue.bodyMoveValueShow.bodyValue.map((item) =>
      item !== null ? parseFloat(parseFloat(item).toFixed(2)) : null
    );
    return this._composeChartDataArray(step, startTime, valueArray);
  }

  //戒指sn
  get ringSN() {
    return this.model.reportInfo.sn;
  }

  async _initTimeTickArray() {
    //基于睡眠分期图表的实际数据范围生成XTickArray
    try {
      const breathPeriodData = await this.getBreathPeriodChartDataArray();
      
      if (!breathPeriodData || breathPeriodData.length === 0) {
        // 如果没有睡眠分期数据，返回空数组
        return [];
      }

      // 从睡眠分期数据中获取实际的开始和结束时间
      const startTimestamp = breathPeriodData[0].xValue; // 毫秒时间戳
      const endTimestamp = breathPeriodData[breathPeriodData.length - 1].xValue; // 毫秒时间戳

      let secondPerHour = 60 * 60 * 1000; // 每小时的毫秒数
      let startIntTimestamp = Math.floor(startTimestamp / secondPerHour) * secondPerHour; //开始时前的整点时间戳
      let endIntTimestamp = Math.ceil(endTimestamp / secondPerHour) * secondPerHour; //结束时后的整点时间戳
      let XTickCount = (endIntTimestamp - startIntTimestamp) / secondPerHour;
      let XTickArray = [];

      //加入每个整点时间戳
      for (let i = 0; i <= XTickCount; i++) {
        let intTimeStamp = startIntTimestamp + i * secondPerHour;
        XTickArray.push(intTimeStamp);
      }

      //真实开始时间替换首位整点时间戳
      XTickArray[0] = startTimestamp;
      //如果第二位整点时间戳与真实开始时间相差不到30分钟，剔除
      if (XTickArray.length > 1 && XTickArray[1] - XTickArray[0] < 0.5 * secondPerHour) {
        XTickArray.splice(1, 1);
      }

      //真实结束时间替换末位整点时间戳
      XTickArray[XTickArray.length - 1] = endTimestamp;
      //如果倒数第二位整点时间戳与真实结束时间相差不到30分钟，剔除
      if (
        XTickArray.length > 1 &&
        XTickArray[XTickArray.length - 1] - XTickArray[XTickArray.length - 2] < 0.5 * secondPerHour
      ) {
        XTickArray.splice(XTickArray.length - 2, 1);
      }

      return XTickArray;
    } catch (error) {
      console.error('Error initializing timeTickArray:', error);
      return [];
    }
  }

  _initTimeChartTickArray() {
    //XTickArray
    let secondPerHour = 60 * 60; //每小时的毫数
    // let startTimestamp = this.startMonitorRawTime;

    let startTimestamp = 1757520525000;
    let startIntTimestamp = Math.floor(startTimestamp / secondPerHour) * secondPerHour; //开始时前的整点时间戳
    // let endTimestamp = this.stopMonitorRawTime;
    let endTimestamp = 1757547911000;
    let endIntTimestamp = Math.ceil(endTimestamp / secondPerHour) * secondPerHour; //结束时后的整点时间戳
    let XTickCount = (endIntTimestamp - startIntTimestamp) / secondPerHour;
    let XTickArray = [];
    //加入每个整点时间戳
    for (let i = 0; i <= XTickCount; i++) {
      let intTimeStamp = startIntTimestamp + i * secondPerHour;
      XTickArray.push(intTimeStamp);
    }
    //真实开始时间替换首位整点时间戳
    XTickArray[0] = startTimestamp;
    //如果第二位整点时间戳与真实开始时间相差不到30分钟，剔除
    if (XTickArray[1] - XTickArray[0] < 0.5 * secondPerHour) {
      XTickArray.splice(1, 1);
    }
    //真实结束时间替换末位整点时间戳
    XTickArray[XTickArray.length - 1] = endTimestamp;
    //如果倒数第二位整点时间戳与真实结束时间相差不到30分钟，剔除
    if (
      XTickArray[XTickArray.length - 1] - XTickArray[XTickArray.length - 2] <
      0.5 * secondPerHour
    ) {
      XTickArray.splice(XTickArray.length - 2, 1);
    }
    return XTickArray.map((item) => {
      return item * 1000;
    });
  }

  _initahiDegreeArray() {
    if (this.reportModeType == DEVICE_MONITOR_MODE.儿童模式) {
      if (this.model.reportInfo.standard == CHILD_STANDDARD_TYPE_CODE["2007版中国指南"]) {
        return AHI_DEGREE_ARRAY.中国儿童;
      } else {
        return AHI_DEGREE_ARRAY.美国儿童;
      }
    } else {
      return AHI_DEGREE_ARRAY.成人;
    }
  }

  _initEvaluateInfo() {
    return this.model.reportInfo.evaluate;
  }

  _initIsEditable() {
    return this.evaluateInfo.type != REPORT_SUGGESTION_TYPE.智能评估;
  }

  _initConclusion() {
    if (this.evaluateInfo.customize == null) {
      return this.evaluateInfo.customize;
    } else {
      switch (this.evaluateInfo.type) {
        case REPORT_SUGGESTION_TYPE.空白模板:
          return "";
        default:
          return this.evaluateInfo.customize;
      }
    }
  }

  _composeTimeArray(step) {
    let timeArray = [];
    let maxIndex = (this.stopMonitorRawTime - this.startMonitorRawTime) / step;
    for (let index = 0; index <= maxIndex; index++) {
      const timeItem = this.startMonitorRawTime + index * step;
      timeArray.push(timeItem);
    }
    return timeArray;
  }

  _composeDataArray(step, startTime, valueArray) {
    let dataArray = [];
    let timeArray = [];
    switch (step) {
      case 1:
        timeArray = this.secondTimeArray;
        break;
      case 30:
        timeArray = this.halfMinuteTimeArray;
        break;
      case 60:
        timeArray = this.minuteTimeArray;
        break;

      default:
        break;
    }
    timeArray.forEach((item) => {
      let index = parseInt((item - startTime) / step);
      let dataItem = {
        xValue: item * 1000,
        yValue: valueArray[index]
      };
      dataArray.push(dataItem);
    });
    return dataArray;
  }

  _composeChartDataArray(step, startTime, valueArray) {
    let dataArray = [];
    valueArray.forEach((value, index) => {
      let dataItem = {
        xValue: startTime + index * step * 1000, // 从startTime开始，每次加step秒(转毫秒)
        yValue: value
      };
      dataArray.push(dataItem);
    });

    return dataArray;
  }

  setbreathWaveDetail(data) {
    this.breathWaveDetail = data;
    this.breathWaveDataArray = data?.contentArr || [];
  }

  get breathWaveChartDataArray() {
    let waveChartData = [];
    for (let i = 0; i < this.breathWaveDataArray.length; i++) {
      const minuteWave = this.breathWaveDataArray[i];
      const minuteWaveStart = minuteWave[0] * 1000;
      const minuteWaveLength = minuteWave[1].length;
      const minuteWaveData = minuteWave[1];
      const minuteWaveInterval = Math.round((60000 / minuteWaveLength) * 100) / 100;
      for (let j = 0; j < minuteWaveLength; j += 10) {
        const d = minuteWaveData[j];
        const t = minuteWaveStart + minuteWaveInterval * j;
        waveChartData.push({
          xValue: t,
          yValue: d
        });
      }
    }
    return waveChartData;
  }

  // 格式化显示字符串的 getter 方法
  get neckCircumferenceStr() {
    return this.initialPatientNeckCircumference ? `${this.initialPatientNeckCircumference}cm` : "";
  }

  get waistCircumferenceStr() {
    return this.model.userInfo?.waistCircumference
      ? `${this.model.userInfo.waistCircumference}cm`
      : "";
  }
  get unitStr() {
    return this.model.reportInfo?.hospitalName ? `${this.model.reportInfo.hospitalName}` : "";
  }

  get chestCircumferenceStr() {
    return this.model.userInfo?.chestCircumference
      ? `${this.model.userInfo.chestCircumference}cm`
      : "";
  }

  get hipCircumferenceStr() {
    return this.model.userInfo?.hipCircumference ? `${this.model.userInfo.hipCircumference}cm` : "";
  }
  
  //体位图标数据
    async positionsChartDataArray() {
    const positionsDataUrl = this.model.detailedArr?.positions;
    const response = await axios.get(positionsDataUrl);
    const positions = response.data;
      //  positions.position: 1，俯卧 2，仰卧 3，左侧卧 4，右侧卧 5，坐起， 6，正在运动（没有固定姿势）
      // positions.time: 体位发生时间 时间戳
    const chartData = positions.map((item) => ({
      xValue: item.time * 1000, // 时间戳转毫秒
      yValue: item.position == 6 ? null : item.position //需求上要求忽略掉值为 6 的数据
    }));
    return chartData;
  }
}

export { ReportModel };
